<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card dir-rtl" style="padding: 29px">
      <div class="diposiFilter">
        <div
          class="listFilter"
          @click="allHandler"
          :class="{ listFilterActive: showAll }"
        >
          <img src="@/assets/icons/tilda.svg" />
          همه
        </div>
        <div
          class="listFilter listFilter-receive"
          @click="receiveHandler"
          :class="{ listFilterActive: diposit }"
        >
          <img src="@/assets/icons/transaction_deposit.svg" />
          دریافت‌ها
        </div>
        <div
          class="listFilter listFilter-pay"
          @click="payHandler"
          :class="{ listFilterActive: pay }"
        >
          <img src="@/assets/icons/transaction_withdraw.svg" />
          پرداخت‌ها
        </div>
      </div>

      <div v-for="transaction in transactionList" :key="transaction.trace_id">
        <div v-if="showAll" class="destination">
          <img :src="`https://media-dev.bfst.ir/${transaction.user.avatar}`" />
          <p
            v-if="
              transaction.user.first_name != null ||
              transaction.user.last_name != null
            "
          >
            {{ transaction.user.first_name }} {{ transaction.user.last_name }}
          </p>
          <p v-else>
            {{ transaction.user.keyword }}
          </p>
          <div>
            <p class="ditail">
              <span v-if="transaction.finish_time == null" class="time-out">
                <img
                  src="@/assets/icons/clock.svg"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
              <span v-else-if="transaction.is_deposit" class="pay">
                <img
                  src="@/assets/icons/transaction_deposit.svg"
                  class="pay"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
              <span v-else-if="!transaction.is_deposit" class="receive">
                <img
                  src="@/assets/icons/transaction_withdraw.svg"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
            </p>
            <p v-if="transaction.finish_time == null" class="time">
              {{ transaction.created_on }}
            </p>
            <p v-else class="time">
              {{ transaction.finish_time }}
            </p>
          </div>
        </div>
      </div>

      <div v-for="transaction in transactionList" :key="transaction.trace_id">
        <div
          class="destination"
          v-show="transaction.is_deposit == diposit && !showAll"
        >
          <img :src="`https://media-dev.bfst.ir/${transaction.user.avatar}`" />
          <p
            v-if="
              transaction.user.first_name != null ||
              transaction.user.last_name != null
            "
          >
            {{ transaction.user.first_name }} {{ transaction.user.last_name }}
          </p>
          <p v-else>
            {{ transaction.user.keyword }}
          </p>
          <div>
            <p class="ditail">
              <span v-if="transaction.finish_time == null" class="time-out">
                <img
                  src="@/assets/icons/clock.svg"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
              <span v-else-if="transaction.is_deposit" class="pay">
                <img
                  src="@/assets/icons/transaction_deposit.svg"
                  class="pay"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
              <span v-else-if="!transaction.is_deposit" class="receive">
                <img
                  src="@/assets/icons/transaction_withdraw.svg"
                  style="width: fit-content"
                />
                {{ formatPrice(transaction.amount) }}
                <span style="font-size: 10px"> ریال </span>
              </span>
            </p>
            <p v-if="transaction.finish_time == null" class="time">
              {{ transaction.created_on }}
            </p>
            <p v-else class="time">
              {{ transaction.finish_time }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer-a style="position: fixed; bottom: 0; width: 100%; background: #fff">
    </footer-a>
  </div>
</template>

<script>
import InsHeader from "../../layouts/transactionsHeader.vue";
import footerA from "../../layouts/footer.vue";
export default {
  components: {
    InsHeader,
    footerA,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  beforeMount() {
    if (this.$store.state.transaction.distinationTransaction == null) {
      this.getTransactionList();
    } else {
      this.transactionList =
        this.$store.state.transaction.distinationTransaction;
    }
  },
  data() {
    return {
      transactionList: [],
      filters: {},
      showAll: true,
      diposit: false,
      pay: false,
    };
  },
  methods: {
    getTransactionList() {
      this.$store.dispatch("transaction/getList", this.filters).then((list) => {
        this.transactionList = list;
      });
    },
    allHandler() {
      this.showAll = true;
      this.pay = false;
      this.diposit = false;
    },
    receiveHandler() {
      this.showAll = false;
      this.diposit = true;
      this.pay = false;
    },
    payHandler() {
      this.showAll = false;
      this.diposit = false;
      this.pay = true;
    },
    goBack() {
      this.$router.back();
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toLocaleString("fa-IR").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style scoped>
.add-card {
  height: 145%;
  overflow: scroll;
}
.destination {
  display: flex;
  align-items: center;
  padding: 9px;
  box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;
  margin-top: 10px;
  justify-content: space-around;
}
.ditail {
  font-family: fd-v;
  display: flex;
  align-items: center;
  align-content: flex-start;
  font-size: 13px;
}

.time {
  font-size: 9px;
  float: left;
  color: #b8b8b8;
  font-family: "fd-v";
  direction: ltr;
}
.pic-name {
  display: flex;
}
.receive {
  display: flex;
  align-items: center;
  filter: invert(64%) sepia(79%) saturate(1837%) hue-rotate(332deg)
    brightness(101%) contrast(92%);
}
.pay {
  display: flex;
  align-items: center;
  filter: invert(54%) sepia(65%) saturate(2737%) hue-rotate(74deg)
    brightness(106%) contrast(106%);
}
.time-out {
  display: flex;
  align-items: center;
  filter: invert(18%) sepia(91%) saturate(2876%) hue-rotate(215deg)
    brightness(93%) contrast(105%);
}
.diposiFilter {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 22px;
}
.listFilter {
  display: flex;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background: #ddd;
  padding: 3px;
  border-radius: 40px;
  font-family: "vazir";
  font-size: 12px;
  padding-left: 6px;
  opacity: 0.5;
}
.listFilterActive {
  opacity: 1;
}
.listFilter img {
  width: 18px;
  margin-left: 6px;
}
.listFilter-pay img {
  width: 18px;
  margin-left: 6px;
  background: #21a2f3;
  filter: invert(1);
  border-radius: 12px;
}

.listFilter-receive img {
  width: 18px;
  margin-left: 6px;
  background: #f321e1;
  filter: invert(1);
  border-radius: 12px;
}
</style>
